/* ==========================================================================
   BELORA - WONDERSKIN MASTER / CEKIRDEK DAVRANIS
   --------------------------------------------------------------------------
   Bagimsiz implementasyon. Wonderskin JS'i KOPYALANMAMISTIR; yalniz olculen
   davranis karakteri (sure, easing, yon, snap) yeniden yazilmistir.

   SOZLESMELER
     - Tek motor: sepet cekmecesi Prestige'in kendi <cart-drawer> ogesidir.
       Bu dosya sepet acma/kapama MANTIGI KURMAZ; ikinci bir cekmece yoktur.
     - Her davranis kendi kokunden delege edilir; global scroll dinleyici yok.
     - prefers-reduced-motion CSS katmaninda saygi gorur; burada ek is yok.
   ========================================================================== */
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------- yardimci */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  /* ================================================================ AKORDIYON
     Tek kok delegasyonu. aria-expanded tek gercek kaynak.
     ---------------------------------------------------------------------- */
  function initAccordions(root) {
    $$('[data-ws-acc]', root).forEach(function (group) {
      if (group.__wsAcc) return;
      group.__wsAcc = true;
      var single = group.getAttribute('data-ws-acc') === 'single';
      on(group, 'click', function (e) {
        var btn = e.target.closest('.ws-acc__btn');
        if (!btn || !group.contains(btn)) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (single && !open) {
          $$('.ws-acc__btn[aria-expanded="true"]', group).forEach(function (b) {
            b.setAttribute('aria-expanded', 'false');
          });
        }
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ============================================================ GENEL ACAR
     aria-expanded tabanli tek dugmeli acilir kapanir (footer akordiyonu vb).
     ---------------------------------------------------------------------- */
  function initToggles() {
    if (document.__wsToggle) return;
    document.__wsToggle = true;
    on(document, 'click', function (e) {
      var b = e.target.closest('[data-ws-toggle]');
      if (!b) return;
      b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  }

  /* ===================================================================== SEKME
     roving tabindex + ok tuslari (WAI-ARIA tabs pattern)
     ---------------------------------------------------------------------- */
  function initTabs(root) {
    $$('[data-ws-tabs]', root).forEach(function (wrap) {
      if (wrap.__wsTabs) return;
      wrap.__wsTabs = true;
      var tabs = $$('[role="tab"]', wrap);
      if (!tabs.length) return;

      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on_ = t === tab;
          t.setAttribute('aria-selected', on_ ? 'true' : 'false');
          t.tabIndex = on_ ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on_;
          // Adimli anlatimda gorsel durum sarmalayicida tutulur (daire + baslik
          // birlikte renk degistirir); tek gercek kaynak yine tab'in kendisidir.
          var holder = t.closest('.ws-steps__item');
          if (holder) holder.setAttribute('aria-selected', on_ ? 'true' : 'false');
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (t) {
        on(t, 'click', function () { select(t, false); });
        on(t, 'keydown', function (e) {
          var i = tabs.indexOf(t);
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* ====================================================================== RAY
     Native scroll-snap. Oklar sadece kaydirir; ayri bir state makinesi yok.
     ---------------------------------------------------------------------- */
  function initRails(root) {
    $$('[data-ws-rail]', root).forEach(function (wrap) {
      if (wrap.__wsRail) return;
      wrap.__wsRail = true;
      var rail = $('.ws-rail', wrap);
      var prev = $('.ws-railnav--prev', wrap);
      var next = $('.ws-railnav--next', wrap);
      if (!rail) return;

      function step() {
        var first = rail.firstElementChild;
        if (!first) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap || '10') || 10;
        return first.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
        var hidden = max <= 2;
        if (prev) prev.hidden = hidden;
        if (next) next.hidden = hidden;
      }
      function go(dir) {
        rail.scrollBy({ left: dir * step(), behavior: RM.matches ? 'auto' : 'smooth' });
      }
      on(prev, 'click', function () { go(-1); });
      on(next, 'click', function () { go(1); });
      on(rail, 'scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      // Gorseller yuklendikce genislik degisir
      $$('img', rail).forEach(function (img) { on(img, 'load', sync); });
    });
  }

  /* ========================================================== OTOMATIK RAY
     OLCULDU (wonderskin.com #WONDERYOU): ray KENDILIGINDEN ilerliyor -
     bir karo adimi, olculen dongu ~2100ms, gecis 300ms; ok veya nokta
     gostergesi YOK, sona gelince basa donuyor.
     Kullanici etkilesimi (isaretci uzerinde, odak icerde, elle kaydirma)
     ilerlemeyi durdurur; `prefers-reduced-motion` acikken HIC calismaz.
     Gorunum disindayken de calismaz.
     ---------------------------------------------------------------------- */
  function initAutoRails(root) {
    $$('[data-ws-autorail]', root).forEach(function (rail) {
      if (rail.__wsAuto) return;
      rail.__wsAuto = true;
      if (RM.matches) return;

      var DELAY = 2100;
      var paused = false, visible = false, timer = null, userScroll = null;

      function step() {
        var first = rail.firstElementChild;
        if (!first) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap || '10') || 10;
        return Math.round(first.getBoundingClientRect().width + gap);
      }
      function tick() {
        if (paused || !visible) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if (max <= 2) return;
        var next = rail.scrollLeft + step();
        rail.scrollTo({ left: next > max ? 0 : next, behavior: 'smooth' });
      }
      function start() { if (!timer) timer = setInterval(tick, DELAY); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      on(rail, 'pointerenter', function () { paused = true; });
      on(rail, 'pointerleave', function () { paused = false; });
      on(rail, 'focusin', function () { paused = true; });
      on(rail, 'focusout', function () { paused = false; });
      /* Elle kaydirma sirasinda ilerleme durur, 3sn sonra devam eder. */
      on(rail, 'pointerdown', function () { paused = true; });
      on(rail, 'touchstart', function () { paused = true; }, { passive: true });
      on(rail, 'touchend', function () {
        clearTimeout(userScroll);
        userScroll = setTimeout(function () { paused = false; }, 3000);
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          if (visible) start(); else stop();
        }, { threshold: 0.2 }).observe(rail);
      } else { visible = true; start(); }

      on(document, 'visibilitychange', function () {
        if (document.hidden) stop(); else if (visible) start();
      });
    });
  }

  /* ================================================================== GALERI
     PDP galerisi: mobilde peek carousel + nokta gostergesi, masaustunde grid.
     ---------------------------------------------------------------------- */
  function initGallery(root) {
    $$('[data-ws-gallery]', root).forEach(function (g) {
      if (g.__wsGal) return;
      g.__wsGal = true;

      /* ================================================================
         GALERI - OLCULEN WONDERSKIN DAVRANISI
         Masaustunde SOL kare capali, kayan eksen YALNIZ sag ray.
         Mobilde capa + ray tek kaydirici (CSS display:contents).
         Bu yuzden "aktif kaydirici" kirilima gore DEGISIR.
         ⚠️ Ok/nokta YOK; gosterge 2px bolumlu cubuk.
         ================================================================ */
      var stage  = $('.ws-gal__stage', g);
      var track  = $('.ws-gal__track', g);
      var anchor = $('.ws-gal__anchor', g);
      var bar    = $('[data-ws-gal-bar]', g);
      if (!stage || !track) return;

      var mqDesktop = window.matchMedia('(min-width: 1024px)');

      function scroller() { return mqDesktop.matches ? track : stage; }

      function cells() {
        /* Masaustu: yalniz raydaki kareler kayar.
           Mobil: capa da bir hucredir ve ILK sirada gelir. */
        var list = $$('.ws-gal__slide', track);
        if (!mqDesktop.matches && anchor) {
          list = $$('.ws-gal__slide', anchor).concat(list);
        }
        return list;
      }

      function index() {
        var sc = scroller(), list = cells();
        if (!list.length) return 0;
        var step = list[0].getBoundingClientRect().width + 5;
        if (step <= 5) return 0;
        return Math.max(0, Math.min(list.length - 1, Math.round(sc.scrollLeft / step)));
      }

      var segs = [];
      function buildBar() {
        if (!bar) return;
        var n = cells().length;
        /* Tek kare varsa gosterge basilmaz - referansta da yok. */
        if (n < 2) { bar.hidden = true; bar.innerHTML = ''; segs = []; return; }
        if (segs.length === n) return;
        bar.innerHTML = '';
        segs = [];
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ws-gal__seg';
          b.setAttribute('aria-label', 'Görsel ' + (i + 1));
          b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          (function (k) { on(b, 'click', function () { goTo(k); }); })(i);
          bar.appendChild(b);
          segs.push(b);
        }
        bar.hidden = false;
      }

      function sync() {
        var i = index();
        for (var k = 0; k < segs.length; k++) {
          segs[k].setAttribute('aria-current', k === i ? 'true' : 'false');
        }
        syncArrows();
      }

      function goTo(i) {
        var sc = scroller(), list = cells();
        if (!list[i]) return;
        sc.scrollTo({ left: list[i].offsetLeft - list[0].offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' });
      }

      var prevBtn = $('[data-ws-gal-prev]', g);
      var nextBtn = $('[data-ws-gal-next]', g);
      on(prevBtn, 'click', function () { goTo(Math.max(0, index() - 1)); });
      on(nextBtn, 'click', function () { goTo(index() + 1); });

      function syncArrows() {
        var n = cells().length, i = index();
        if (prevBtn) prevBtn.disabled = i <= 0;
        if (nextBtn) nextBtn.disabled = i >= n - 1;
      }

      on(stage, 'scroll', sync, { passive: true });
      on(track, 'scroll', sync, { passive: true });

      function refresh() { buildBar(); sync(); }
      refresh();

      /* Kirilim degisince kayan eksen ve bolum sayisi da degisir. */
      if (mqDesktop.addEventListener) {
        mqDesktop.addEventListener('change', function () {
          stage.scrollLeft = 0; track.scrollLeft = 0; segs = []; refresh();
        });
      }
      /* Gorseller gec yuklendiginde hucre genisligi degisebilir. */
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () { sync(); });
        ro.observe(stage);
      }
    });
  }

  /* ====================================================== GORSEL KARSILASTIRMA
     Native range input; klavye ile de calisir (erisilebilirlik).
     ---------------------------------------------------------------------- */
  function initCompare(root) {
    $$('[data-ws-compare]', root).forEach(function (c) {
      if (c.__wsCmp) return;
      c.__wsCmp = true;
      var range = $('.ws-cmp__range', c);
      if (!range) return;
      function apply() { c.style.setProperty('--ws-cmp-pos', range.value + '%'); }
      on(range, 'input', apply);
      apply();
    });
  }

  /* ================================================================= CEKMECE
     Menu ve arama icin. Odak tuzagi + Escape + odak geri verme.
     Sepet BU MOTORU KULLANMAZ (tema kendi cekmecesini yonetir).
     ---------------------------------------------------------------------- */
  var openPanel = null;
  var lastFocus = null;

  function focusables(el) {
    return $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null; });
  }

  function closePanel() {
    if (!openPanel) return;
    var p = openPanel;
    openPanel = null;
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
    /* ⚠️ Arama kapatilirken SONUC PANELI de kapanmali. Aksi halde
       Escape'ten sonra input daralip kayboluyor ama acilir sonuc
       listesi ekranda asili kaliyordu (olculdu). */
    var sres = p.querySelector('.ws-search__results');
    if (sres) { sres.hidden = true; sres.innerHTML = ''; }
    var sinp = p.querySelector('.ws-search__input');
    if (sinp) sinp.value = '';
    var scrim = document.getElementById(p.getAttribute('data-ws-scrim') || '');
    if (scrim) scrim.classList.remove('is-open');
    $$('[aria-controls="' + p.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.documentElement.classList.remove('ws-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  function openThePanel(p, trigger) {
    if (openPanel === p) return closePanel();
    if (openPanel) closePanel();
    lastFocus = trigger || document.activeElement;
    openPanel = p;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    var scrim = document.getElementById(p.getAttribute('data-ws-scrim') || '');
    if (scrim) scrim.classList.add('is-open');
    $$('[aria-controls="' + p.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    /* OLCULEN REFERANS (live-search, `research/s16-refmob`):
         MASAUSTU (>=768) arama satir ici acilir -> `body/html overflow` VISIBLE,
                    karartma opakligi 0, pointer-events none. SAYFA KILITLENMEZ.
         MOBIL      tam genislik yuzey -> `overflow: hidden` (kilit VAR) +
                    rgba(0,0,0,0.7) karartma opaklik 1.
       Menu cekmecesi her kirilimda kilitlenmeye devam eder; istisna YALNIZ
       satir ici masaustu aramasidir. */
    var inlineSearch = p.hasAttribute('data-ws-search') &&
      window.matchMedia('(min-width: 768px)').matches;
    if (!inlineSearch) document.documentElement.classList.add('ws-locked');
    /* Satir ici masaustu aramasi MODAL DEGILDIR (karartma yok, kilit yok,
       sayfa etkilesime acik). `aria-modal` yalniz gercekten modal olan
       mobil yuzeyde dogru bilgidir. */
    p.setAttribute('aria-modal', inlineSearch ? 'false' : 'true');
    var f = focusables(p);
    window.setTimeout(function () { if (f[0]) f[0].focus(); }, 60);
  }

  function initPanels() {
    if (document.__wsPanels) return;
    document.__wsPanels = true;

    on(document, 'click', function (e) {
      var t = e.target.closest('[data-ws-open]');
      if (t) {
        var p = document.getElementById(t.getAttribute('data-ws-open'));
        if (p) { e.preventDefault(); openThePanel(p, t); }
        return;
      }
      if (e.target.closest('[data-ws-close]')) { e.preventDefault(); closePanel(); return; }
      if (e.target.classList && e.target.classList.contains('ws-scrim')) return closePanel();
      /* DISARI TIKLAMA - olculen referans davranisi: panel disina tiklaninca
         arama ESC ile AYNI sekilde kapanir (input 118'e doner, opaklik 0).
         ⚠️ Satir ici masaustu aramasinda karartma YOKTUR, dolayisiyla
         `.ws-scrim` tiklamasi hic olusmaz; kapanisi yakalayacak baska bir
         yol da yoktu - panel acik kaliyordu (olculdu). Mobilde karartma
         zaten bu iSi gorur, o yuzden kosul satir ici duruma bakar. */
      if (openPanel && openPanel.hasAttribute('data-ws-search') &&
          window.matchMedia('(min-width: 768px)').matches &&
          !e.target.closest('#' + openPanel.id)) {
        closePanel();
      }
    });

    on(document, 'keydown', function (e) {
      if (!openPanel) return;
      if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(openPanel);
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ================================================================== MODAL
     Marka modali. ⚠️ KUPON POPUP'I DEGIL.

     Acilma kosulu: HEM sure HEM kaydirma esigi. Sayfa aciliminda hemen
     acilmaz. Sepet/checkout akisinda ve ayni oturumda ikinci kez acilmaz.
     Odak tuzagi ve Escape yukaridaki panel motorundan gelir.
     ---------------------------------------------------------------------- */
  function initModal() {
    var box = $('[data-ws-modal]');
    if (!box || document.__wsModal) return;
    document.__wsModal = true;

    // Satin alma akisinda musteriyi kesmeyiz.
    var path = location.pathname;
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0 ||
        path.indexOf('/account') === 0) return;

    var key = box.getAttribute('data-key') || 'ws-modal';
    try { if (sessionStorage.getItem(key)) return; } catch (e) { /* engelli depolama */ }

    var delay = (parseFloat(box.getAttribute('data-delay')) || 8) * 1000;
    var need = parseFloat(box.getAttribute('data-scroll'));
    if (isNaN(need)) need = 25;

    var timeDone = false;
    var scrollDone = need <= 0;
    var opened = false;

    function pct() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      return h > 0 ? (window.scrollY / h) * 100 : 100;
    }

    function remember() {
      try { sessionStorage.setItem(key, '1'); } catch (e) { /* yoksay */ }
    }

    function maybeOpen() {
      if (opened || !timeDone || !scrollDone) return;
      opened = true;
      remember();
      box.hidden = false;
      // hidden kalkinca bir kare bekle ki gecis calissin
      window.requestAnimationFrame(function () {
        box.classList.add('is-open');
        var f = focusables(box);
        window.setTimeout(function () { if (f[0]) f[0].focus(); }, 80);
      });
      document.documentElement.classList.add('ws-locked');
      lastFocus = document.activeElement;
      openPanel = box;
    }

    function close() {
      if (!opened) return;
      box.classList.remove('is-open');
      openPanel = null;
      document.documentElement.classList.remove('ws-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
      window.setTimeout(function () { box.hidden = true; }, 260);
    }

    window.setTimeout(function () { timeDone = true; maybeOpen(); }, delay);
    if (!scrollDone) {
      var onScroll = function () {
        if (pct() >= need) { scrollDone = true; window.removeEventListener('scroll', onScroll); maybeOpen(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    on(box, 'click', function (e) {
      if (e.target.closest('[data-ws-modal-close]')) { e.preventDefault(); close(); }
    });
    // Escape: panel motoru `openPanel`i kapatiyor; modal kendi kapanisini yapar.
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && opened && !box.hidden) { e.preventDefault(); close(); }
    });
  }

  /* ================================================= SEPET CEKMECESI HAREKETI
     OLCULDU (canli referans UpCart, rAF kare yakalama @1440):
       ACILIS  panel x 1440 -> 940, sure ~230ms, YAVASLAYARAK (ease-out)
       KAPANIS panel x 940 -> 1440, sure ~260ms
       ORTU    opaklik SABIT 0.4 - SOLMA YOK (ac/kapa)
       Bilesenin kendi CSS gecisi de 0.249s okuyor -> 249ms kullaniliyor.
     PRESTIGE VARSAYILANI: her ikisi de 300ms + ortu 0->1 SOLMASI
     (`theme.js` Drawer.createEnter/LeaveAnimationControls).
     ⚠️ `theme.js` CEKIRDEK dosyadir; tema yukseltmesinde degisiklik
     KAYBOLUR. Bu yuzden cekirdek DUZENLENMEZ - `cart-drawer` prototipi
     burada, yuklendikten sonra ezilir. Yalniz SEPET cekmecesi etkilenir;
     menu/arama cekmeceleri Prestige varsayilaninda kalir. */
  function patchCartDrawerMotion() {
    var CD = window.customElements && window.customElements.get('cart-drawer');
    if (!CD || CD.prototype.__wsMotion) return;
    var DUR = 249;                                   // olculen referans
    var EASE_IN  = 'cubic-bezier(0.4, 0, 1, 1)';     // kapanis: hizlanarak
    var EASE_OUT = 'cubic-bezier(0, 0, 0.2, 1)';     // acilis: yavaslayarak
    function part(el, name) { return el.getShadowPartByName(name); }
    function run(el, opening) {
      var content = part(el, 'content'), overlay = part(el, 'overlay');
      var off = 'translateX(calc(var(--transform-logical-flip) * 100%))';
      if (content) content.style.marginInlineStart = 'auto';
      /* Ortu SOLMAZ: referansta opaklik sabit. Sadece varligi degisir. */
      if (overlay) overlay.style.opacity = opening ? '1' : '0';
      var frames = opening ? [{ transform: off }, { transform: 'translateX(0)' }]
                           : [{ transform: 'translateX(0)' }, { transform: off }];
      var anim = content
        ? content.animate(frames, { duration: DUR, easing: opening ? EASE_OUT : EASE_IN, fill: 'both' })
        : { finished: Promise.resolve(), finish: function () {} };
      return anim;
    }
    CD.prototype.createEnterAnimationControls = function () { return run(this, true); };
    CD.prototype.createLeaveAnimationControls = function () { return run(this, false); };
    CD.prototype.__wsMotion = true;
  }

    /* ========================================================= BELORA ACCESS
     CANLI PARITE (2026-08-31). Onceki gecuste bu fonksiyon BOS bir govdeyle
     birakilmisti (`function initAccess() {}`) - yani kart hicbir sinif
     almiyordu. CANLI tema #155718582428'de hareket VARDIR ve sahibin
     hatirladigi isik gecisi buradan gelir:
       gorunume girince (IntersectionObserver, esik 0.5) -> `is-in`
         · kart perspective(600px) rotateY(-8deg) egilir
         · uzerinden TEK bir isik gecer (1.05s, 0.15s gecikme, 1 kez)
       1250ms sonra -> `is-settled` -> kart duz durusuna doner
     Azaltilmis harekette hic calismaz (asagidaki `reduce` kapisi).
     ⚠️ Surekli donme, dongu veya rAF YOK. */
  function initAccess(root) {
    if (!('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-ws-access]', root).forEach(function (el) {
      if (el.__wsAcc) return;
      el.__wsAcc = true;
      if (reduce) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          el.classList.add('is-in');
          // Kart egik kalmaz: isik gectikten sonra duz durusuna doner.
          window.setTimeout(function () { el.classList.add('is-settled'); }, 1250);
        });
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }


  /* ============================================== DAVRANISA DAYALI YARDIM
     ⚠️ SAHTE ACELE YOK. Sayac, sahte stok, sahte izleyici, sahte siparis
        bildirimi URETILMEZ. Yalniz musterinin GERCEK etkilesim durumu
        okunur ve yardim TEK BIR yerde, sessizce belirginlesir.

     Kurallar:
       A) Beden secilmeden sepete ekle denenirse -> BEDENIMI BUL belirginlesir.
       B) Beden yardimi acilip TAMAMLANMAZSA -> WhatsApp yolu one cikar.
       C) Sayfanin derinine inilip hala sepete eklenmemisse -> satin alma
          alanina donus daveti (mevcut bilesenle, yeni kutu acmadan).
       D) Sepete eklendiginde -> urunu ANLATMAYI BIRAK, tum yardim susar.
     ---------------------------------------------------------------------- */
  function initAssist() {
    if (document.__wsAssist) return;
    document.__wsAssist = true;

    var buy = $('[data-ws-atc]');
    if (!buy) return;
    var sizeHelp = $('[data-ws-open="ws-sizefinder"]');
    var root = document.documentElement;

    var added = false;
    var finderOpened = false;
    var finderDone = false;

    function stopTeaching() {
      added = true;
      root.classList.add('ws-has-cart');
      root.classList.remove('ws-assist-size', 'ws-assist-wa', 'ws-assist-deep');
    }

    // D) Sepete eklendi -> her sey susar.
    document.addEventListener('cart:change', stopTeaching);
    document.addEventListener('cart:refresh', stopTeaching);
    if (buy) buy.addEventListener('click', function () {
      if (!buy.disabled) window.setTimeout(stopTeaching, 400);
    });

    // A) Beden secilmeden satin almaya yaklasma.
    function sizeMissing() {
      var hidden = document.querySelector('product-form input[name="id"]');
      return !(hidden && hidden.value);
    }
    if (sizeHelp) {
      // ⚠️ DEVRE DISI bir butona yapilan tiklama olay URETMEZ - beden
      //    secilmeden ATC zaten devre disi oldugu icin `click` hic gelmiyordu.
      //    "Satin almaya yaklasma" bu yuzden ATC'nin GORUNUR OLMASIYLA
      //    olculur; bu ayni zamanda daha durust bir sinyal.
      if ('IntersectionObserver' in window) {
        var bio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting || added) return;
            if (sizeMissing()) root.classList.add('ws-assist-size');
          });
        }, { threshold: 0.9 });
        bio.observe(buy);
      }
      // Beden secilir secilmez vurgu kalkar.
      on(document, 'change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.ws-opt__values')) {
          root.classList.remove('ws-assist-size');
        }
      });
    }

    // B) Beden yardimi acildi ama tamamlanmadi -> WhatsApp yolu one cikar.
    on(document, 'click', function (e) {
      var t = e.target.closest && e.target.closest('[data-ws-open]');
      if (t && /sizefinder/.test(t.getAttribute('data-ws-open') || '')) finderOpened = true;
      if (e.target.closest && e.target.closest('[data-ws-size-submit],[data-ws-size-result]')) finderDone = true;
    });
    document.addEventListener('ws:size-result', function () { finderDone = true; });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') maybeWhatsapp(); });
    function maybeWhatsapp() {
      if (added || !finderOpened || finderDone) return;
      window.setTimeout(function () {
        if (!finderDone && !added) root.classList.add('ws-assist-wa');
      }, 600);
    }
    on(document, 'click', function (e) {
      if (e.target.closest && e.target.closest('[data-ws-close]')) maybeWhatsapp();
    });

    // C) Derine inildi, hala sepete eklenmedi.
    var deepFired = false;
    function onScroll() {
      if (added || deepFired) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      if (window.scrollY / h >= 0.55) {
        deepFired = true;
        root.classList.add('ws-assist-deep');
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ================================================== SECIM SUREKLILIGI
     Ziyaretci daha once bir beden sectiyse ve AYNI OTURUMDA geri donerse
     secimi geri yukleriz. Amac SURTUNMEYI azaltmak.

     ⚠️ Sahte aciliyet URETILMEZ: "bedenini ayirdik", "son X adet",
        geri sayim YOK. Gercek bir rezervasyon olmadigi icin rezervasyon
        ima edilmez.
     ⚠️ `sessionStorage` kullanilir - kalici takip degil, oturum suresince.
        Depolama engelliyse sessizce vazgecilir.
     ---------------------------------------------------------------------- */
  function initContinuity() {
    if (document.__wsCont) return;
    document.__wsCont = true;
    var form = document.querySelector('product-form');
    if (!form) return;
    var handle = (document.querySelector('[data-ws-pricemap]') && location.pathname) || location.pathname;
    var KEY = 'ws-size:' + handle;

    function store() {
      var checked = document.querySelector('.ws-opt__values input:checked');
      if (!checked) return;
      try { sessionStorage.setItem(KEY, checked.value || checked.id || ''); } catch (e) { /* yoksay */ }
    }
    on(document, 'change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.ws-opt__values')) store();
    });

    // Geri donuste: secim ZATEN varsa dokunma; yoksa oncekini geri yukle.
    var pre = document.querySelector('.ws-opt__values input:checked');
    if (pre) return;
    var saved = null;
    try { saved = sessionStorage.getItem(KEY); } catch (e) { return; }
    if (!saved) return;
    var target = null;
    $$('.ws-opt__values input').forEach(function (i) {
      if (!target && (i.value === saved || i.id === saved)) target = i;
    });
    if (!target || target.disabled) return;
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
    var note = $('[data-ws-continuity]');
    if (note) note.hidden = false;
  }

  /* ============================================================ MENU SEKMELERI
     Mobil menude ust duzey sekmeler (Wonderskin drawer__tabs karsiligi).
     ---------------------------------------------------------------------- */
  function initMenuTabs(root) {
    $$('[data-ws-menutabs]', root).forEach(function (wrap) {
      if (wrap.__wsMt) return;
      wrap.__wsMt = true;
      on(wrap, 'click', function (e) {
        var b = e.target.closest('.ws-menu__tab');
        if (!b) return;
        $$('.ws-menu__tab', wrap).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        var id = b.getAttribute('aria-controls');
        $$('.ws-menu__tabpanel', wrap).forEach(function (p) { p.hidden = p.id !== id; });
      });
    });
  }

  /* ================================================================ MEGA MENU
     OLCULEN REFERANS ZAMANLAMASI (`research/n03-refmegamotion`, @1440)
       ACILMA GECIKMESI  0ms  - hover'in ilk karesinde `is-visible`
       ACILMA SURESI     200ms opacity ease-out
       KAPANMA GECIKMESI 0ms  - "hosgoru" beklemesi YOK
       KAPANMA           ANLIK (visibility gecikmesiz; bkz. ws-chrome.css)
       A -> B            capraz gecis; A anlik gizlenir, B 200ms acilir
       KOPRU             tetikleyici -> panel gecisinde titreme YOK
     ⚠️ BELORA `mouseleave`te 120ms bekliyordu. Bu, referansta OLMAYAN bir
     gecikme: fare nav'dan ciktiktan sonra panel 120ms daha acik kaliyor,
     A->B gecisinde de eski panel yeni panelin uzerinde bir kare fazla
     duruyordu. Bekleme kaldirildi.
     KOPRU: panel ZATEN `.ws-nav__item`in cocugu ve hemen altinda oldugu
     icin tetikleyiciden panele inerken `mouseleave` hic tetiklenmez -
     referansla ayni; ayri bir "hover koprusu" dolgusu gerekmez.
     ⚠️ ESCAPE: olculdu, referans mega'yi Escape ile KAPATMIYOR. BELORA
     kapatir - bilincli erisilebilirlik sapmasi (klavye kullanicisi icin
     cikis yolu); fare kullanicisi icin gorunur fark yoktur.
     ---------------------------------------------------------------------- */
  function initMega(root) {
    var bar = $('[data-ws-mega]', root || document);
    if (!bar || bar.__wsMega) return;
    bar.__wsMega = true;

    function show(item) {
      $$('.ws-nav__item', bar).forEach(function (n) {
        var on_ = n === item;
        n.classList.toggle('is-open', on_);
        var t = $('.ws-nav__top', n);
        if (t && t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', on_ ? 'true' : 'false');
      });
      document.documentElement.classList.toggle('ws-mega-open', !!item);
    }

    $$('.ws-nav__item', bar).forEach(function (item) {
      if (!$('.ws-mega', item)) return;
      on(item, 'mouseenter', function () { show(item); });
      on(item, 'mouseleave', function () { show(null); });
      var top = $('.ws-nav__top', item);
      on(top, 'focus', function () { show(item); });
      on(top, 'click', function (e) {
        if (top.tagName === 'BUTTON') { e.preventDefault(); show(item.classList.contains('is-open') ? null : item); }
      });
      on(item, 'focusout', function (e) {
        if (!item.contains(e.relatedTarget)) show(null);
      });
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') show(null);
    });
  }

  /* ================================================================== ARAMA
     Shopify predictive search. Ek kutuphane yok.
     ---------------------------------------------------------------------- */
  function initSearch(root) {
    $$('[data-ws-search]', root).forEach(function (box) {
      if (box.__wsSearch) return;
      box.__wsSearch = true;
      var input = $('input[type="search"], input[name="q"]', box);
      var out = $('.ws-search__results', box);
      if (!input || !out) return;
      var t = null;
      var ctrl = null;

      function render(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('#ws-predictive') || doc.querySelector('[data-ws-predictive]');
        out.innerHTML = res ? res.innerHTML : '';
        out.hidden = !out.innerHTML.trim();
      }

      on(input, 'input', function () {
        window.clearTimeout(t);
        var q = input.value.trim();
        if (q.length < 2) { out.hidden = true; out.innerHTML = ''; return; }
        t = window.setTimeout(function () {
          if (ctrl) ctrl.abort();
          ctrl = new AbortController();
          var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') +
            'search/suggest?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6&section_id=ws-predictive';
          fetch(url, { signal: ctrl.signal })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (h) { if (h) render(h); })
            .catch(function () { /* iptal edildi */ });
        }, 220);
      });
    });
  }

  /* ============================================================ MOBIL ANONS
     Marquee sure hesabi: sabit hiz (px/sn), icerik uzunluguna gore sure.
     Boylece kisa mesajlar hizli, uzun mesajlar yavas akmaz.
     ---------------------------------------------------------------------- */
  function initMarquee(root) {
    $$('[data-ws-marquee]', root).forEach(function (m) {
      if (m.__wsMq) return;
      m.__wsMq = true;
      var track = $('.ws-ann__track', m);
      if (!track) return;
      function size() {
        var first = track.firstElementChild;
        if (!first) return;
        var w = first.getBoundingClientRect().width;
        if (!w) return;
        var speed = parseFloat(m.getAttribute('data-ws-marquee')) || 55; // px/sn
        track.style.setProperty('--ws-mq-dur', (w / speed).toFixed(2) + 's');
        m.classList.toggle('is-scrolling', w > m.clientWidth);
      }
      size();
      window.addEventListener('resize', size);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
    });
  }

  /* ========================================================= SATIN ALMA KAPISI
     Prestige'in `product:rerender` zinciri yalniz kendi tanidigi blok
     tiplerini yeniler. Bu bolumun satin alma satiri onlardan biri degil, bu
     yuzden buton durumu sunucudan gelen ILK degerde takili kaliyordu
     (olculdu: beden secildikten sonra `disabled` kaliyordu).

     ⚠️ TEK GERCEK KAYNAK: formun kendi gizli `id` alani. Burada PARALEL bir
     varyant state'i tutulmaz, sepete istek atilmaz; yalnizca zaten dogru olan
     duruma gore ETIKET ve `disabled` guncellenir.
     ---------------------------------------------------------------------- */
  function initBuyGate() {
    if (document.__wsBuy) return;
    document.__wsBuy = true;

    /* Varyant -> bicimlenmis fiyat. Bicimlendirme SUNUCUDAN gelir; burada
       para birimi/ayirac tahmin edilmez. Harita yoksa fiyat oldugu gibi kalir. */
    var PRICES = (function () {
      var el = document.querySelector('[data-ws-pricemap]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    })();

    function paintPrice(variant) {
      if (!PRICES || !variant || !variant.id) return;
      var row = PRICES[String(variant.id)];
      if (!row) return;
      /* Fiyat IKI yuzeyde de tazelenir: mobil satir + ATC dugmesi.
         ⚠️ `innerHTML` ile dugmenin ic yapisi EZILMEZ; ustu cizili
         karsilastirma dugumu korunur (olculen referansta indirimli
         urunde dugme iki fiyat tasir). */
      var now = $('[data-ws-price-now]');
      var was = $('[data-ws-price-compare]');
      if (now) now.textContent = row.now;
      if (was) { was.textContent = row.was; was.hidden = !row.sale; }
      /* OLCULDU (referans indirimli PDP, m390): urun INDIRIMDEYKEN guncel
         fiyat mor (#5F39A4 `price on-sale`), indirimsizken #4C4C4C.
         Durum, secili VARYANTIN kendi `compare_at > price` bilgisinden
         gelir; renk CSS'te `[data-ws-sale]` ile secilir. Varyant her
         degistiginde burada tazelendigi icin bayat renk kalmaz. */
      var priceBox = document.querySelector('[data-ws-price]');
      if (priceBox) {
        if (row.sale) priceBox.setAttribute('data-ws-sale', '');
        else priceBox.removeAttribute('data-ws-sale');
      }
      var aNow = $('[data-ws-atc-now]');
      var aWas = $('[data-ws-atc-was]');
      if (aNow) aNow.textContent = row.now;
      if (aWas) { aWas.textContent = row.was; aWas.hidden = !row.sale; }
    }

    function sync(variant) {
      var btn = $('[data-ws-atc]');
      if (!btn) return;

      var hidden = document.querySelector('product-form input[name="id"]');
      var hasVariant = !!(hidden && hidden.value && !hidden.disabled);
      var available = variant ? variant.available !== false : hasVariant;

      var labelEl = $('[data-ws-atc-label]', btn);
      var priceEl = $('[data-ws-atc-price]', btn);
      var showPrice = btn.getAttribute('data-show-price') === '1';

      var state;
      if (!hasVariant) state = 'size';
      else if (!available) state = 'sold';
      else state = 'add';

      /* ⚠️ SEPETE EKLEME SURERKEN DOKUNMA. `sync()` her varyant degisiminde
         ve `change` olayinda calisir; bekleme/basari durumundaki dugmeyi
         yeniden etkinlestirirse tek-ucus kilidi GORSEL olarak kirilir ve
         musteri ikinci kez basabilir. Durum sahibi o an ATC denetleyicisidir. */
      var wsState = btn.getAttribute('data-ws-state');
      if (wsState === 'pending' || wsState === 'success') return;

      if (labelEl) labelEl.textContent = btn.getAttribute('data-label-' + state) || labelEl.textContent;
      btn.disabled = state !== 'add';
      if (btn.disabled) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
      /* ⚠️ Fiyat 'beden secin' durumunda da gorunur - ayri fiyat satiri
         referans mimarisine uyacak sekilde kaldirildi (bkz. ws-pdp.css). */
      if (priceEl) priceEl.hidden = !showPrice;

      // Secim basligindaki kalin deger
      if (variant && variant.options) {
        variant.options.forEach(function (val, i) {
          var node = document.querySelector('[data-ws-opt-value="' + (i + 1) + '"]');
          if (node && val) node.textContent = val;
        });
      } else {
        var checked = $$('.ws-opt__values input:checked');
        checked.forEach(function (inp) {
          var pos = inp.getAttribute('data-option-position');
          var lab = document.querySelector('label[for="' + inp.id + '"]');
          var node = document.querySelector('[data-ws-opt-value="' + pos + '"]');
          if (node && lab) node.textContent = lab.getAttribute('data-value') || lab.textContent.trim();
        });
      }
    }

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant ? e.detail.variant : null;
      paintPrice(v);
      sync(v);
    });
    // Radyo tiklamasi rerender'dan once de gorunur geri bildirim vermeli.
    on(document, 'change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.ws-opt__values')) {
        window.setTimeout(function () { sync(null); }, 0);
      }
    });
    sync(null);
  }

  /* ============================================================ UGC VIDEO
     Olculen referansta rayda video ve gorsel karisik duruyor. Otomatik
     oynatma YOK: kart tiklaninca oynar, ikinci tiklamada durur. Ayni anda
     tek video oynar - mobil veri ve CPU icin.
     ---------------------------------------------------------------------- */
  function initUgcVideo(root) {
    $$('[data-ws-ugcvideo]', root).forEach(function (box) {
      if (box.__wsUgc) return;
      box.__wsUgc = true;
      var v = box.querySelector('video');
      if (!v) return;
      v.setAttribute('playsinline', '');
      v.muted = true;
      v.loop = true;
      function toggle() {
        if (v.paused) {
          $$('[data-ws-ugcvideo] video').forEach(function (o) { if (o !== v) { o.pause(); var oc = o.closest('[data-ws-ugcvideo]'); if (oc) oc.classList.remove('is-playing'); } });
          var pr = v.play();
          if (pr && pr.then) pr.then(function () { box.classList.add('is-playing'); }).catch(function () {});
          else box.classList.add('is-playing');
        } else {
          v.pause();
          box.classList.remove('is-playing');
        }
      }
      on(box, 'click', function (e) { e.preventDefault(); toggle(); });
      on(box.querySelector('.ws-ugc__play, .ws-vgrid__play'), 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
      on(v, 'ended', function () { box.classList.remove('is-playing'); });
    });
  }

  /* ================================================================== BASLAT */
  function boot(root) {
    initAccordions(root);
    initTabs(root);
    initRails(root);
    initAutoRails(root);
    initGallery(root);
    initCompare(root);
    initMenuTabs(root);
    initMega(root);
    initSearch(root);
    initMarquee(root);
    initPanels();
    initModal();
    initAccess(document);
    patchCartDrawerMotion();
    initAssist();
    initContinuity();
    initToggles();
    initBuyGate();
    initUgcVideo(root);
  }


  /* ------------------------------------------------- SEPET DOLU DURUMU
     Sepet ikonundaki "iceri dusen parca" hareketi YALNIZ sepet doluyken
     calisir (olculen referans sozlesmesi: [data-header-cart-full]).
     Sunucudan basilan durum AJAX ile sepete ekleme sonrasi bayatlar;
     tema cekirdeginin `cart:change` / `cart:refresh` olaylari ile
     senkron tutulur.
     ⚠️ `<cart-count>` metnine bakilmaz - o eleman baska bir zamanlamada
     guncelleniyor; sayi dogrudan olay yukunden okunur. */
  function setCartFull(n) {
    var on = Number(n) > 0;
    document.querySelectorAll('.ws-hdr__ico[href*="/cart"]').forEach(function (a) {
      if (on) { a.setAttribute('data-ws-cart-full', ''); }
      else { a.removeAttribute('data-ws-cart-full'); }
    });
  }
  document.addEventListener('cart:change', function (e) {
    if (e && e.detail && e.detail.cart) setCartFull(e.detail.cart.item_count);
  });
  document.addEventListener('cart:refresh', function () {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) setCartFull(c.item_count); })
      .catch(function () {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme Editor: bolum yeniden yuklendiginde tekrar baglan
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });

  window.WSCore = { boot: boot, closePanel: closePanel };
})();

/* ==========================================================================
   SOSYAL KANIT - iki mesaj arasinda sabit araliklı gecis
   --------------------------------------------------------------------------
   ⚠️ Deger URETMEZ: sayilar Liquid'den gelir, burada yalniz hangi mesajin
   gorunecegi degisir. Rastgele YOK, artis YOK, istek YOK.
   Sekme arka plandayken zamanlayici durur (gereksiz is yapilmaz).
   ========================================================================== */
(function () {
  'use strict';
  function boot(scope) {
    (scope || document).querySelectorAll('[data-ws-sp]').forEach(function (box) {
      if (box.__wsSp) return;
      box.__wsSp = true;
      var msgs = box.querySelectorAll('[data-ws-sp-msg]');
      if (msgs.length < 2) return;
      var gap = parseInt(box.getAttribute('data-interval'), 10);
      if (!gap || gap < 600) gap = 2000;
      var i = 0, timer = null;
      function show(n) {
        for (var k = 0; k < msgs.length; k++) msgs[k].classList.toggle('is-on', k === n);
      }
      function tick() { i = (i + 1) % msgs.length; show(i); }
      function start() { if (!timer) timer = setInterval(tick, gap); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      show(0);
      start();
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
